/**
 * https://www.pdftron.com/api/web/Core.html#isBlendModeSupported__anchor
 * @see https://www.pdftron.com/api/web/Core.html#isBlendModeSupported__anchor
 */
export default (type) => window.Core.isBlendModeSupported(type);
